import React from 'react';
import { useInView } from 'react-intersection-observer';

export interface WaypointProps {
    onEnter: () => void;
}

export const Waypoint = ({ onEnter }: WaypointProps): React.JSX.Element => {
    const handleChange = (inView: boolean, entry: IntersectionObserverEntry) => {
        if (inView) {
            onEnter();
        }
    };

    const { ref } = useInView({
        threshold: 1,
        triggerOnce: true,
        root: null,
        onChange: handleChange,
    });

    return <div ref={ref} />;
};
